module.exports = __webpack_public_path__ + "img/scout-2.9ce1231f.jpg";